import { Directive, OnInit, ElementRef, HostListener, forwardRef, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as BulmaCalendar from './bulma-calendar.js';

@Directive({
  selector: '[appDatepicker]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatepickerDirective),
    multi: true
  }]
})
export class DatepickerDirective implements OnInit, OnDestroy, ControlValueAccessor {
  private calendar: any;
  private readonly dateFormat = 'dd-mm-yyyy';
  private onChangeCallback: (value: Date) => void;
  private onTouchedCallback: () => void;

  @Input() maxdate: Date;
  @Input() mindate: Date;
  @Input() open: boolean;
  @Input() closeOnSelect: boolean;
  @Input() startDate: Date;
  @Input() showPrevNext: boolean;
  @Input() meetId: string;
  @Output() changedDate: EventEmitter<Date> = new EventEmitter<Date>();

  constructor(private elementRef: ElementRef) { }

  get nativeElement(): HTMLInputElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.calendar = new BulmaCalendar(this.nativeElement, {
      closeOnSelect: this.closeOnSelect,
      dateFormat: this.dateFormat,
      maxDate: this.maxdate,
      minDate: this.mindate,
      showPrevNext: this.showPrevNext,
      meetId: this.meetId,
      startDate: this.startDate,
      onSelect: selectedDate => this.onDateSelected(selectedDate)
    });

    if (this.open) {
      this.calendar.show();
    }

    document.body.removeChild(this.calendar.datePickerContainer);
    this.nativeElement.parentElement.insertBefore(this.calendar.datePickerContainer,
      this.nativeElement.parentElement.firstElementChild);
  }

  ngOnDestroy() {
    this.calendar.destroy();
  }

  @HostListener('blur')
  onBlur() {
    this.onTouchedCallback();
  }

  @HostListener('input')
  onInputChange() {
    const parts = this.nativeElement.value.split('-');
    if (parts.length !== 3) {
      this.onChangeCallback(null);
    } else {
      const typedDate = new Date(+parts[2], +parts[1] - 1, +parts[0]);
      this.onChangeCallback(typedDate);
    }
  }

  onDateSelected(date: Date) {
    this.onChangeCallback(date);
    this.writeValue(date);
    this.calendar.show();
  }

  writeValue(date: Date): void {
    this.nativeElement.value = date ? `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}` : null;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.nativeElement.disabled = isDisabled;
  }
}
